    <template>
        <div class="ele-body">
            <el-card shadow="never">
                <!-- 搜索表单 -->
                <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                    @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                    <el-row :gutter="15">
                        <el-form-item label="模板名称:">
                            <el-input v-model="table.where.title" placeholder="请输入模板名称" clearable />
                        </el-form-item>
                        <el-form-item label="店铺:">
                            <el-select v-model="table.where.shop_id" filterable placeholder="请选择">
                                <el-option v-for="item in store_shop_management_list" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="是否包邮:">
                            <el-select v-model="table.where.parcel" filterable placeholder="请选择">
                                <el-option label="卖家承担" :value="1"></el-option>
                                <el-option label="买家承担" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="费用计算方式:">
                            <el-select v-model="table.where.method" filterable placeholder="请选择">
                                <el-option label="按重量计算" value="1"></el-option>
                                <el-option label="按商品件数计算" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="创建时间:">
                            <el-date-picker v-model="table.where.create_time" type="datetimerange"
                                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                            <el-button type="success" @click="exportExcel();" icon="el-icon-download"
                                class="ele-btn-icon" v-if="permission.includes('sys:logisticsfare:export')">导出数据
                            </el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
                <!-- 操作按钮 -->
                <div class="ele-table-tool ele-table-tool-default">
                    <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                        class="ele-btn-icon" size="small">刷新
                    </el-button>
                    <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon"
                        size="small" v-if="permission.includes('sys:logisticsfare:add')">添加
                    </el-button>
                    <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                        v-if="permission.includes('sys:logisticsfare:dall')">批量删除
                    </el-button>
                    <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                        @click="search_show=!search_show">搜索</el-button>
                </div>

                <!-- 数据表格 -->
                <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                    highlight-current-row>
                    <template slot-scope="{index}">
                        <el-table-column type="selection" width="45" align="center" fixed="left" />
                        <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                            show-overflow-tooltip />

                        <el-table-column prop="title" label="模板名称" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        <el-table-column prop="shop_id" label="店铺" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-tag v-for="(item,index) in row.shop_id_info" :key="index">{{item.name}}</el-tag>
                            </template>
                        </el-table-column>
<el-table-column prop="fare_price" label="起送金额" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        <el-table-column prop="parcel" label="是否包邮" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-tag v-if="row.parcel == 1" :key="index">卖家承担</el-tag>
                                <el-tag v-if="row.parcel == 2" :key="index">买家承担</el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column prop="method" label="费用计算方式" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <div v-if="row.parcel == 1">
                                    <el-tag>免费</el-tag>
                                </div>
                                <div v-else>
                                    <el-tag v-if="row.method == 1" :key="index">按重量计算</el-tag>
                                    <el-tag v-if="row.method == 2" :key="index">按商品件数计算</el-tag>
                                </div>
                                
                            </template>
                        </el-table-column>


                        

                        <el-table-column prop="first_price" label="首费" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="renew_weight" label="续重" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="renew_price" label="续费（元）" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        <el-table-column prop="shop_id_info.name" label="店铺名称" sortable="custom" show-overflow-tooltip
                            min-width="120">
                            <template slot-scope="{row}">
                                <div v-for="(item,index) in row.shop_id_info" :key="index">
                                    {{ item.name }}
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                            <template slot-scope="{row}">
                                <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                    v-if="permission.includes('sys:logisticsfare:edit')">修改</el-link>
                                <el-popconfirm title="确定要删除此运费设置吗？" @confirm="remove(row)" class="ele-action">
                                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                        v-if="permission.includes('sys:logisticsfare:delete')">删除</el-link>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </template>
                </ele-data-table>
            </el-card>
            <!-- 编辑弹窗 -->
            <el-dialog :title="editForm.id?'修改运费设置':'添加运费设置'" :visible.sync="showEdit" width="800px"
                :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">

                    <el-form-item label="模板名称:" prop="title">
                        <el-input v-model="editForm.title" placeholder="请输入模板名称" clearable />
                    </el-form-item>


                    <el-form-item label="店铺:" prop="shop_id">
                        <el-select v-model="editForm.shop_id" filterable placeholder="请选择">
                            <el-option v-for="item in store_shop_management_list" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="起送金额(元)：" prop="fare_price">
                        <el-input-number v-model="editForm.fare_price" controls-position="right" :min="0"
                            placeholder="请输入起送金额(元)" class="ele-fluid ele-text-left" />
                    </el-form-item>
                    <el-form-item label="是否包邮：" prop="parcel">
                        <el-radio-group v-model="editForm.parcel">
                            <el-radio label="1">卖家承担</el-radio>
                            <el-radio label="2">买家承担</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div v-if="editForm.parcel == 2" style="margin-bottom: 20px;">
                        <el-form-item label="计价方式：" prop="method">
                            <el-radio-group v-model="editForm.method">
                                <el-radio label="1">按重量计算</el-radio>
                                <el-radio label="2">按商品件数计算</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        
                        <el-form-item :label="editForm.method==1?'首重(kg)：':'首件(件)：'" prop="first_weight">
                            <el-input v-model="editForm.first_weight"
                                :placeholder="editForm.method==1?'请输入首重(kg)：':'请输入首件(件)：'" clearable />
                        </el-form-item>
                        
                        <el-form-item label="首费(元)：" prop="first_price">
                            <el-input-number v-model="editForm.first_price" controls-position="right" :min="0"
                                placeholder="请输入首费(元)" class="ele-fluid ele-text-left" />
                        </el-form-item>
                        <el-form-item :label="editForm.method==1?'续重(kg)：':'续件(件)：'" prop="renew_weight">
                            <el-input v-model="editForm.renew_weight"
                                :placeholder="editForm.method==1?'请输入续重(kg)：':'请输入续件(件)：'" clearable />
                        </el-form-item>
                        
                        <el-form-item label="续费(元)：" prop="renew_price">
                            <el-input-number v-model="editForm.renew_price" controls-position="right" :min="0"
                                placeholder="请输入续费(元)" class="ele-fluid ele-text-left" />
                        </el-form-item>
                    </div>
                    
                    <el-form-item label="发货地区：">
                        <el-select v-model="province_value" placeholder="省" @change="provinceChange">
                            <el-option v-for="(item,index) in province_data" :key="index" :label="item.label"
                                :value="index">
                            </el-option>
                        </el-select>
                        <el-select v-model="city_value" placeholder="市" @change="cityChange">
                            <el-option v-for="(item,index) in city_data" :key="index" :label="item.label"
                                :value="index">
                            </el-option>
                        </el-select>
                        <el-select v-model="area_value" placeholder="区">
                            <el-option v-for="(item,index) in area_data" :key="index" :label="item.label"
                                :value="index">
                            </el-option>
                        </el-select>
                        <el-button type="text" @click="addCity">添加</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-tag v-for="(tag,index) in select_address" :key="index" closable
                            @close="closeAddress(index)">
                            {{tag.province}} {{tag.city}} {{tag.area}}
                        </el-tag>
                    </el-form-item>
                </el-form>
                <div slot="footer">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </el-dialog>
        </div>
    </template>

    <script>
        import {
            mapGetters
        } from "vuex";
    import cityDataAll from '@/utils/cityData'

        export default {
            name: "SyslogisticsFare",
            components: {},
            data() {
                return {
                    select_address: [],
                    province_data: [],
                    city_data: [],
                    area_data: [],
                    province_value: '',
                    city_value: '',
                    area_value: '',
                    table: {
                        url: '/logistics/LogisticsFare/index',
                        where: {}
                    }, // 表格配置
                    choose: [], // 表格选中数据
                    showEdit: false, // 是否显示表单弹窗
                    editForm: {
                        parcel:1,
                        method:1
                    }, // 表单数据
                    editFormTemp: {},
                    admin_list: [],
                    user_list: [],
                    search_show: false,
                    store_shop_management_list: [],
                    editRules: { // 表单验证规则

                        title: [{
                            required: true,
                            message: '请输入模板名称',
                            trigger: 'blur'
                        }],
                        shop_id: [{
                            required: true,
                            message: '请选择店铺',
                            trigger: 'blur'
                        }],
                        parcel: [{
                            required: true,
                            message: '请选择是否包邮',
                            trigger: 'blur'
                        }],
                        method: [{
                            required: true,
                            message: '请选择费用计算方式',
                            trigger: 'blur'
                        }],
                        first_weight: [{
                            required: true,
                            message: '请输入首重',
                            trigger: 'blur'
                        }],
                        first_price: [{
                            required: true,
                            message: '请输入首费',
                            trigger: 'blur'
                        }],
                        renew_weight: [{
                            required: true,
                            message: '请输入续重',
                            trigger: 'blur'
                        }],
                        renew_price: [{
                            required: true,
                            message: '请输入续费（元）',
                            trigger: 'blur'
                        }],
                        create_time: [{
                            required: true,
                            message: '请选择创建时间',
                            trigger: 'blur'
                        }],
                        name: [{
                            required: true,
                            message: '请输入店铺名称',
                            trigger: 'blur'
                        }],
                    },
                }
            },
            computed: {
                ...mapGetters(["permission"]),
            },
            mounted() {
                this.province_data = JSON.parse(JSON.stringify(cityDataAll.cityData));
                var data = {
                    label: '全部',
                    value: '全部'
                }
                this.province_data.unshift(data)
                this.StoreShopManagementAllList();
            },
            methods: {
                closeAddress(index){
                    this.select_address.splice(index,1);
                },
                /* 市*/
                provinceChange(e) {
                    if (e != 0) {
                        this.city_data = JSON.parse(JSON.stringify(this.province_data[e].children));
                        var data = {
                            label: '全部',
                            value: '全部'
                        }
                        this.city_data.unshift(data)
                        this.area_data = [];
                        this.city_value = '';
                        this.area_value = '';
                    } else {
                        this.city_data = [];
                        this.area_data = [];
                        this.city_value = '';
                        this.area_value = '';
                    }
                },
                /* 区*/
                cityChange(e) {
                    if (e != 0) {
                        this.area_data = JSON.parse(JSON.stringify(this.city_data[e].children));
                        var data = {
                            label: '全部',
                            value: '全部'
                        }
                        this.area_data.unshift(data)
                    } else {
                        this.area_data = [];
                        this.area_value = '';
                    }
                },
                /* 添加地区 */
                addCity() {
                    if (this.province_value === '') {
                        return false;
                    }
                    var province = '';
                    var city = '';
                    var area = '';
                    if (this.province_value === 0) {
                        province = '全部';
                    } else {
                        province = this.province_data[this.province_value].label;
                        if (this.city_value != '') {
                            if (this.city_value === 0) {
                                city = '全部';
                            } else {
                                city = this.city_data[this.city_value].label;
                                if (this.area_value != '') {
                                    if (this.area_value === 0) {
                                        area = '全部';
                                    } else {
                                        area = this.area_data[this.area_value].label;
                                    }
                                }

                            }
                        }

                    }
                    var temp_info = {
                        province: province,
                        city: city,
                        area: area
                    }
                    this.select_address.push(temp_info);
                },
                /**
                 * 关闭
                 */
                closeDialog() {
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit(row) {
                    this.$http.get('/logistics/LogisticsFare/info?id=' + row.id).then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                this.editForm = res.data.data;
                                this.select_address = [];
                                this.select_address = res.data.data.select_address;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            const loading = this.$loading({
                                lock: true
                            });
                            if(this.editForm.parcel == 1){
                                this.editForm.first_weight = 0;
                                this.editForm.first_price = 0;
                                this.editForm.renew_weight = 0;
                                this.editForm.renew_price = 0;
                            }
                            this.editForm.select_address = JSON.stringify(this.select_address);
                            this.$http.post('/logistics/LogisticsFare/edit', this.editForm).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    console.log(row)
                    if (!row) { // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的运费设置吗?', '提示', {
                            type: 'warning'
                        }).then(() => {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/logistics/LogisticsFare/delete', {
                                id: ids
                            }).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else { // 单个删除
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/logistics/LogisticsFare/delete', {
                            id: row.id
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                /* 导出数据Excel */
                exportExcel() {
                    let ids = this.choose.map(d => d.id)
                    if (ids.length == 0) {
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/logistics/LogisticsFare/exportExcel", {
                            id: ids
                        })
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },

                //查询其他信息
                StoreShopManagementAllList() {
                    this.$http.post('/store/StoreShopManagement/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            this.store_shop_management_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },

            }
        }
    </script>

    <style scoped>
        .ele-block>>>.el-upload,
        .ele-block>>>.el-upload-dragger {
            width: 100%;
        }
    </style>